import { client } from '@api/client';
import { URL } from '@api/urls';

import {
	IActiveAlarmOran,
	IActiveAlarmsFlexidas,
	IAlarmHistoryFlexidas,
	IAlarmInformation,
} from '@interfaces/alarms/alarm';
import {
	IAcknowledgeAlarmDTO,
	IActiveAlarmOranDTO,
	IAlarmHistoryDTO,
	IGetAlarmFlexidasDTO,
} from '@interfaces/alarms/dto/alarmsDTO';
import { IId } from '@interfaces/common/common';
import { IItemsResponse } from '@interfaces/common/response';

const {
	alarmHistory,
	alarmActiveOran,
	alarmActiveFlexidas,
	alarmHistoryFlexidas,
	alarmActiveFlexidasByAlarmId,
} = URL;

export const getAlarmHistory = (
	data: IAlarmHistoryDTO,
): Promise<IItemsResponse<IAlarmInformation>> => {
	return client.get(alarmHistory, {
		params: data,
	});
};

export const getActiveAlarm = (
	id: string,
): Promise<IAlarmInformation> => {
	return client.get(`${alarmHistory}/${id}`);
};

export const getActiveAlarms = (
	data: IAlarmHistoryDTO,
): Promise<IItemsResponse<IAlarmInformation>> => {
	return client.get(`${alarmHistory}/active`, {
		params: data,
	});
};

export const getActiveOranAlarm = (id: string): Promise<IActiveAlarmOran> => {
	return client.get(`${alarmActiveOran}/${id}`);
};

export const getActiveOranAlarms = (
	params: IActiveAlarmOranDTO,
): Promise<IItemsResponse<IActiveAlarmOran>> => {
	return client.get(`${alarmActiveOran}/filter`, {
		params,
	});
};

export const getActiveAlarmsFlexidas = (
	data: IGetAlarmFlexidasDTO,
): Promise<IItemsResponse<IActiveAlarmsFlexidas>> => {
	return client.get(alarmActiveFlexidas, {
		params: data,
	});
};

export const getActiveAlarmFlexidas = (
	id: string,
): Promise<IActiveAlarmsFlexidas> => {
	return client.get(alarmActiveFlexidasByAlarmId, { params: { alarmId: id } });
};

export const getHistoryAlarmFlexidas = (
	id: string,
): Promise<IAlarmHistoryFlexidas> => {
	return client.get(`${alarmHistoryFlexidas}/${id}`);
};

export const getAlarmHistoryFlexidas = (
	data: IGetAlarmFlexidasDTO,
): Promise<IItemsResponse<IAlarmHistoryFlexidas>> => {
	return client.get(alarmHistoryFlexidas, {
		params: data,
	});
};

export const clearAlarmOran = ({ id }: IId): Promise<IActiveAlarmOran> => {
	return client.get(`${alarmActiveOran}/${id}/clear`);
};

export const acknowledgeAlarmOran = ({
	id,
	...params
}: IAcknowledgeAlarmDTO): Promise<IActiveAlarmOran> => {
	return client.get(`${alarmActiveOran}/${id}/acknowledged`, { params });
};
